var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_Google.svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_Google.svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M15.04 8.166q-.002-.78-.133-1.5H8v2.84h3.947a3.38 3.38 0 0 1-1.474 2.207v1.847h2.38c1.387-1.28 2.187-3.16 2.187-5.394"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M8 15.333c1.98 0 3.64-.653 4.853-1.773l-2.38-1.847c-.653.44-1.487.707-2.473.707-1.907 0-3.527-1.287-4.107-3.02h-2.44v1.893A7.33 7.33 0 0 0 8 15.333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M3.893 9.393A4.4 4.4 0 0 1 3.66 8c0-.487.087-.953.233-1.393V4.713h-2.44C.953 5.7.667 6.813.667 8s.286 2.3.786 3.287l1.9-1.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M8 3.587c1.08 0 2.04.373 2.807 1.093l2.1-2.1C11.633 1.393 9.98.667 8 .667a7.32 7.32 0 0 0-6.547 4.046l2.44 1.893c.58-1.733 2.2-3.02 4.107-3.02"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_Google.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_Google.svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgGoogle;